import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/labradorpuppies_v2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/labradorpuppies_v2/src/components/ui/AppIcon.tsx");
